/**
 * Paywall english translation
 */
export const PAYWALL_EN = {
  tryNow: 'Try Now!',
  unlockFeature: 'Unlock this Feature',
  seeMore: 'See More!',
  callToUpgradeReward: 'Upgrade your Subscription to see more of your past Generations!'
}

/**
 * Paywall german translation
 */
export const PAYWALL_DE = {
  tryNow: 'Jetzt testen!',
  unlockFeature: 'Funktion freischalten',
  seeMore: 'Mehr anzeigen',
  callToUpgradeReward: 'Upgrade dein Abonnement, um mehr deiner erstellten Inhalte zu sehen!'
}
